<template>
  <article class="overflow-hidden">
    <div class="relative text-white rounded text-2xl font-bold overflow-hidden">
      <!-- CATS,SANDBOX and a few other <img alt="Placeholder" class="block h-40 w-auto rounded-sm object-cover mx-auto" :src="nft.nft_image" /> -->
      <!-- most items <img alt="Placeholder" class="block h-auto w-full rounded-sm object-cover" :src="nft.nft_image" /> -->
      <a :href="`https://opensea.io/assets/matic/${nft.nft_contract}/${nft.nft_id}`" target="_blank">
      <img alt="Placeholder" class="block h-auto w-full rounded-sm object-cover" :src="nft.nft_image" />
      </a>
      <div v-if="parseInt(nft.availabe_quantity) > 1" class="ribbon bg-red-500 text-sm whitespace-no-wrap pt-1">x{{nft.availabe_quantity}}</div>
    </div>
    <header class="flex items-center justify-between leading-tight tracking-wide">
      <h1 class="text-white text-left text-base font-bold pt-4">{{nft.nft_title}}</h1>
    </header>

    <footer
      class="flex items-center text-white text-sm justify-between leading-5 tracking-wide pt-2 pb-8"
    >{{nft.nft_description}}</footer>
  </article>
</template>


<script>
export default {
  name: "GalleryItem",
  components: {},

  props: {
    nft: Object
  },
  computed: {},
  data: function() {
    return {};
  },
  beforeMount: async function() {
    //console.log(this.nft);
  },
  methods: {},
  mounted: async function() {},
  computed: {}
};
</script>

<style scoped>
  .ribbon {
    position: absolute;
    top: 0;
    right: 0;
    width: 150px;
    height: 22px;
    margin-right: -50px;
    margin-top: 15px;
    text-align: center;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Safari prior 9.0 */
    transform: rotate(45deg); /* Standard syntax */
  }
</style>